<template>
    <v-dialog
        v-model="dialog"
        width="500"
    >
        <template v-slot:activator="{ on, attrs }">
        <v-btn
            v-bind="attrs"
            v-on="on"
            tile 
            color="primary" 
            small 
        >
            <v-icon color="white">mdi-chart-donut</v-icon>
        </v-btn>
        </template>

        <v-card>
        <v-card-title
            class="headline primary white--text"
            primary-title
        >
            Lead Stats
        </v-card-title>

        <v-list class="pa-0">
            <template v-for="(stat, i) in stats">
                <v-divider :key="`dv-${i}`"></v-divider>
                <v-list-item
                    :key="i"
                >
                    <v-list-item-content>
                        <v-list-item-title v-text="stat.label"></v-list-item-title>
                    </v-list-item-content>
                    <v-spacer></v-spacer>
                    <v-list-item-action class="ma-0 text-right">
                        {{ stat.percentage + '%' }}
                    </v-list-item-action>
                </v-list-item>
            </template>
        </v-list>

        <v-divider></v-divider>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
            color="primary"
            text
            @click="dialog = false"
            >
            Close
            </v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['stats'],
    data () {
        return {
            dialog: false,
        }
    },
}
</script>

<style lang="sass" scoped>
.headline 
    padding: 14px 15px!important
</style>